import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Utils from 'helpers/utils.js';
import { Button, PageHero, PageLoader, Section } from '@kambria/kambria-lego';
import { fetchDaoDetail, fetchDaoCodebases } from './actions';
import { Container, Row, Col } from 'reactstrap';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import './style.css';
import { Tabs, Tab } from '@mui/material';

import enums from 'helpers/const';
import defaultImage from 'static/images/hero-banner-2022.png';
import background from 'static/images/bounty-header.png';
import DevPaymentTab from './tabs/DevPaymentTab';
import BountyTab from './tabs/BountyTab';
import EvaluationTab from './tabs/EvaluationTab';
import VestingTab from './tabs/VestingTab';
import SyncGTLPTab from './tabs/SyncGTLPTab';
import SolutionsViewClaimTab from './tabs/SolutionsViewClaimTab';
import SolutionsManagementTab from './tabs/SolutionsManagementTab';
import VotingTab from './tabs/VotingTab';
import EngagementTab from './tabs/EngagementTab';
import VestingViewClaimTab from './tabs/VestingViewClaimTab';
import ServiceRevenueSharingTab from './tabs/ServiceRevenueSharingTab';
import RevenueItemsTab from './tabs/RevenueItemsTab';
import { VestingAbi } from './abis';
import VestingMainTab from './tabs/VestingMainTab';
import SolutionsMainTab from './tabs/SolutionsMainTab';
import CodebaseTab from './tabs/CodebaseTab';

class DaoDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listLicenses: [],
      allDaos: [],
      userWalletID: '',
      metamaskStatus: false,
      error: null,
      activeTab: 0,
    };
  }

  style = {
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  };

  componentDidMount() {
    const { id } = this.props.match.params;
    try {
      this.props.fetchDaoDetail(id);
      this.props.fetchDaoCodebases(id);
    } catch (error) {
      console.error('Error fetching DAO:', error);
      this.setState({
        error: 'Failed to load DAO information. Please try again later.',
      });
    }

    // Check for tab query parameter
    this.checkTabQueryParam();
  }

  checkTabQueryParam = () => {
    const searchParams = new URLSearchParams(this.props.location.search);
    const tabParam = searchParams.get('tab');

    const tabIndexes = {
      voting: 7,
      'revenue-items': 4,
    };

    if (tabParam && tabIndexes[tabParam] !== undefined) {
      this.setState({ activeTab: tabIndexes[tabParam] });
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.currentDao !== this.props.currentDao) {
    }

    // Check tab query param if location search changed
    if (prevProps.location.search !== this.props.location.search) {
      this.checkTabQueryParam();
    }
  }

  render() {
    const { currentDao, loading } = this.props;
    const { error } = this.state;

    const bannerBackground = currentDao && currentDao.banner ? currentDao.banner : background;
    const headerStyle = {
      ...this.style,
      backgroundImage: `url(${bannerBackground})`,
    };

    if (error) {
      return (
        <div id="site_wrapper">
          <div className="site-upper" style={headerStyle}>
            {this.props.header}
            <PageHero headline="Error" description="Something went wrong" />
          </div>
          <main className="main bounty-home">
            <div id="content" className="bounty-content container">
              <Section title="Error" className="card-section">
                <Row>
                  <Col lg="12">
                    <Card
                      sx={{
                        backgroundColor: '#2A2E33',
                        borderRadius: '8px',
                        overflow: 'hidden',
                      }}
                    >
                      <CardContent>
                        <Typography variant="h6" color="white" gutterBottom>
                          {error}
                        </Typography>
                        <Button component={Link} to="/dao" variant="contained" color="primary" sx={{ mt: 2 }}>
                          Back to DAO List
                        </Button>
                      </CardContent>
                    </Card>
                  </Col>
                </Row>
              </Section>
            </div>
          </main>
          {this.props.footer}
        </div>
      );
    }

    return (
      <div id="site_wrapper">
        <div className="site-upper" style={headerStyle}>
          {this.props.header}
          <PageHero
          // headline={currentDao ? `${currentDao.name} (${currentDao.code})` : 'DAO Detail'}
          // description="View DAO information"
          />
        </div>
        <main className="main bounty-home">
          <div id="content" className="bounty-content">
            <PageLoader loading={loading} />

            {currentDao && (
              <Section className="card-section">
                <h2
                  className="heading"
                  style={{
                    textAlign: 'left',
                    fontVariant: 'tabular-nums',
                    fontFeatureSettings: "'tnum', 'tnum'",
                    minHeight: 0,
                    minWidth: 0,
                    outline: '0 none !important',
                    boxSizing: 'border-box',
                    fontFamily: 'inherit',
                    lineHeight: 1.2,
                    marginBottom: '0.5em',
                    fontWeight: 500,
                    color: '#f4f8f9',
                    fontSize: '28px',
                    marginTop: '58px',
                  }}
                >
                  {currentDao.name}
                </h2>

                <Card
                  sx={{
                    backgroundColor: '#282f38',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    marginBottom: '20px',
                    border: '1px solid #00EDC3',
                  }}
                >
                  <CardContent sx={{ p: 4 }}>
                    <Box sx={{ mb: 6 }}>
                      <Typography
                        variant="h4"
                        sx={{
                          color: '#00EDC3',
                          fontSize: '48px',
                          fontWeight: 300,
                          textAlign: 'center',
                          mb: 3,
                          fontFamily: 'Questrial, normal',
                          letterSpacing: '0.5px',
                        }}
                      >
                        DAO Information
                      </Typography>
                    </Box>

                    <Row>
                      <Col lg="4">
                        <Box sx={{ mb: 4 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              color: '#00EDC3',
                              fontSize: '28px',
                              fontWeight: 300,
                              mb: 3,
                              fontFamily: 'Questrial, normal',
                              letterSpacing: '0.5px',
                            }}
                          >
                            Basic Information
                          </Typography>
                          <Box
                            sx={{
                              backgroundColor: '#282f38',
                              borderRadius: '16px',
                              p: 4,
                              border: '1px solid #00EDC3',
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{ mb: 3, fontSize: '20px', fontFamily: 'Questrial, normal', letterSpacing: '0.5px' }}
                            >
                              <span style={{ color: '#00EDC3', fontWeight: 300 }}>DAO Code</span>{' '}
                              <span style={{ color: '#e7e3e3', fontWeight: 300 }}>{currentDao.code}</span>
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ mb: 3, fontSize: '20px', fontFamily: 'Questrial, normal', letterSpacing: '0.5px' }}
                            >
                              <span style={{ color: '#00EDC3', fontWeight: 300 }}>Status</span>{' '}
                              <span style={{ color: '#e7e3e3', fontWeight: 300 }}>{currentDao.status}</span>
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ fontSize: '20px', fontFamily: 'Questrial, normal', letterSpacing: '0.5px' }}
                            >
                              <span style={{ color: '#00EDC3', fontWeight: 300 }}>Created At</span>{' '}
                              <span style={{ color: '#e7e3e3', fontWeight: 300 }}>
                                {new Date(currentDao.createdAt).toLocaleDateString()}
                              </span>
                            </Typography>
                          </Box>
                        </Box>
                      </Col>

                      <Col lg="8">
                        <Box sx={{ mb: 4 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              color: '#00EDC3',
                              fontSize: '28px',
                              fontWeight: 300,
                              mb: 3,
                              fontFamily: 'Questrial, normal',
                              letterSpacing: '0.5px',
                            }}
                          >
                            Contract Addresses
                          </Typography>
                          <Box
                            sx={{
                              backgroundColor: '#282f38',
                              borderRadius: '16px',
                              p: 4,
                              border: '1px solid #00EDC3',
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{ mb: 3, fontSize: '20px', fontFamily: 'Questrial, normal', letterSpacing: '0.5px' }}
                            >
                              <span style={{ color: '#00EDC3', fontWeight: 300 }}>GT Token</span>{' '}
                              <span style={{ color: '#e7e3e3', fontWeight: 300 }}>{currentDao.gtTokenAddress}</span>
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ mb: 3, fontSize: '20px', fontFamily: 'Questrial, normal', letterSpacing: '0.5px' }}
                            >
                              <span style={{ color: '#00EDC3', fontWeight: 300 }}>LP Token</span>{' '}
                              <span style={{ color: '#e7e3e3', fontWeight: 300 }}>{currentDao.lpTokenAddress}</span>
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ fontSize: '20px', fontFamily: 'Questrial, normal', letterSpacing: '0.5px' }}
                            >
                              <span style={{ color: '#00EDC3', fontWeight: 300 }}>Service Revenue Sharing</span>{' '}
                              <span style={{ color: '#e7e3e3', fontWeight: 300 }}>
                                {currentDao.serviceRevenueSharingAddress}
                              </span>
                            </Typography>
                          </Box>
                        </Box>
                      </Col>
                    </Row>

                    {/* Tabs Section */}
                    <Row>
                      <Col lg="3">
                        <Card
                          sx={{
                            backgroundColor: '#282f38',
                            borderRadius: '16px',
                            overflow: 'hidden',
                            marginBottom: '20px',
                            border: '1px solid #00EDC3',
                            height: '100%',
                          }}
                        >
                          <CardContent sx={{ p: 2 }}>
                            <Tabs
                              orientation="vertical"
                              value={this.state.activeTab}
                              onChange={(event, newValue) => this.setState({ activeTab: newValue })}
                              sx={{
                                '& .MuiTab-root': {
                                  color: '#F4F4F4',
                                  fontSize: '16px',
                                  fontWeight: 400,
                                  textTransform: 'none',
                                  padding: '12px 24px',
                                  minWidth: 'unset',
                                  fontFamily: 'Questrial, normal',
                                  alignItems: 'flex-start',
                                  justifyContent: 'flex-start',
                                  textAlign: 'left',
                                  whiteSpace: 'normal',
                                  '&.Mui-selected': {
                                    color: '#00EDC3',
                                    backgroundColor: 'rgba(0, 237, 195, 0.1)',
                                  },
                                  '&:hover': {
                                    color: '#00EDC3',
                                    backgroundColor: 'rgba(0, 237, 195, 0.05)',
                                  },
                                },
                                '& .MuiTabs-indicator': {
                                  backgroundColor: '#00EDC3',
                                  width: '2px',
                                },
                              }}
                            >
                              <Tab label="Milestone Payment" />
                              <Tab label="Bounty" />
                              <Tab label="Vesting" />
                              <Tab label="Service Revenue Sharing" />
                              <Tab label="Sync GT - LP" />
                              <Tab label="Codebase" />
                              <Tab label="Voting" />
                              <Tab label="Engagement" />
                              <Tab label="Revenue Items" />
                              {/*<Tab label="Codebase" />*/}
                            </Tabs>
                          </CardContent>
                        </Card>
                      </Col>
                      <Col lg="9">
                        <Card
                          sx={{
                            backgroundColor: '#282f38',
                            borderRadius: '16px',
                            overflow: 'hidden',
                            marginBottom: '20px',
                            border: '1px solid #00EDC3',
                            height: '100%',
                          }}
                        >
                          <CardContent sx={{ p: 4 }}>
                            {this.state.activeTab === 0 && (
                              <DevPaymentTab
                                daoOrganizerAddress={currentDao.organizerAddress}
                                chainId={currentDao.chainId}
                              />
                            )}
                            {this.state.activeTab === 1 && (
                              <BountyTab
                                daoOrganizerAddress={currentDao.organizerAddress}
                                daoId={currentDao._id}
                                chainId={currentDao.chainId}
                              />
                            )}
                            {this.state.activeTab === 2 && (
                              <VestingMainTab
                                daoOrganizerAddress={currentDao.organizerAddress}
                                chainId={currentDao.chainId}
                              />
                            )}
                            {this.state.activeTab === 3 && (
                              <ServiceRevenueSharingTab
                                daoOrganizerAddress={currentDao.organizerAddress}
                                chainId={currentDao.chainId}
                                currentDao={currentDao}
                              />
                            )}
                            {this.state.activeTab === 4 && (
                              <SyncGTLPTab
                                daoOrganizerAddress={currentDao.organizerAddress}
                                chainId={currentDao.chainId}
                              />
                            )}
                            {this.state.activeTab === 5 && (
                              <SolutionsMainTab
                                daoOrganizerAddress={currentDao.organizerAddress}
                                chainId={currentDao.chainId}
                                currentDao={currentDao}
                                daoId={currentDao._id}
                                daoInfo={currentDao}
                                daoCodebases={this.props.daoCodebases}
                              />
                            )}
                            {this.state.activeTab === 6 && (
                              <VotingTab
                                chainId={currentDao.chainId}
                                currentDao={currentDao}
                                daoOrganizerAddress={currentDao.organizerAddress}
                              />
                            )}
                            {this.state.activeTab === 7 && (
                              <EngagementTab
                                chainId={currentDao.chainId}
                                currentDao={currentDao}
                                daoOrganizerAddress={currentDao.organizerAddress}
                              />
                            )}
                            {this.state.activeTab === 8 && (
                              <RevenueItemsTab
                                chainId={currentDao.chainId}
                                currentDao={currentDao}
                                onRefreshDao={() => this.props.fetchDaoDetail(this.props.match.params.id)}
                              />
                            )}
                            {/*{this.state.activeTab === 8 && (*/}
                            {/*  <CodebaseTab*/}
                            {/*    daoOrganizerAddress={currentDao.organizerAddress}*/}
                            {/*    daoId={currentDao._id}*/}
                            {/*    chainId={currentDao.chainId}*/}
                            {/*    daoInfo={currentDao}*/}
                            {/*  />*/}
                            {/*)}*/}
                          </CardContent>
                        </Card>
                      </Col>
                    </Row>
                  </CardContent>
                </Card>
              </Section>
            )}
          </div>
        </main>
        {this.props.footer}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentDao: state.dao?.currentDao || null,
    daoCodebases: state.dao?.daoCodebases || [],
    loading: state.dao?.loading || false,
  };
};

const mapDispatchToProps = {
  fetchDaoDetail,
  fetchDaoCodebases,
};

export default connect(mapStateToProps, mapDispatchToProps)(DaoDetail);
